import styled, { css } from 'styled-components';
import { Button, Layout } from 'antd';
import { Link } from 'react-router-dom';
import { media } from '@app/styles/themes/constants';
import { LAYOUT } from '@app/styles/themes/constants';

export const Sider = styled(Layout.Sider)`
  position: fixed;
  overflow: visible;
  right: 0;
  z-index: 5;
  min-height: 100vh;
  max-height: 100vh;

  color: var(--text-secondary-color);

  @media only screen and ${media.md} {
    right: unset;
    left: 0;
  }

  @media only screen and ${media.xl} {
    position: unset;
  }

  &.sider-calib {
    background: #0c0c0c !important;
    border-right: none !important;

    .ant-menu {
      background: transparent !important;
      border-right: none !important;
    }
    .ant-menu-item,
    .ant-menu-submenu-title {
      color: #fff !important;
      padding: 14px 24px !important;
      height: auto !important;
      line-height: 1.5 !important;
      font-size: 0.9375rem !important;
      margin: 0 !important;
    }
    .ant-menu-item-icon,
    .ant-menu-submenu-title .anticon {
      color: #fff !important;
      font-size: 1.125rem !important;
    }
    .ant-menu-item-selected {
      background-color: rgba(255, 255, 255, 0.15) !important;
      color: #fff !important;
      border: none !important;

      &::after {
        display: none !important;
      }
    }
    .ant-menu-item:hover,
    .ant-menu-submenu-title:hover {
      background-color: rgba(255, 255, 255, 0.08) !important;
      color: #fff !important;
    }
    .ant-menu-submenu-popup .ant-menu {
      background: #0c0c0c !important;
      border: none !important;
    }
    .ant-menu-submenu-popup .ant-menu-item {
      padding: 14px 24px 14px 48px !important;
    }
  }

  &.sider-kaizen {
    background: #0c0c0c !important;
    border-right: none !important;

    .ant-menu {
      background: transparent !important;
      border-right: none !important;
    }
    .ant-menu-item,
    .ant-menu-submenu-title {
      color: #fff !important;
      padding: 14px 24px !important;
      height: auto !important;
      line-height: 1.5 !important;
      font-size: 0.9375rem !important;
      margin: 0 !important;
    }
    .ant-menu-item-icon,
    .ant-menu-submenu-title .anticon {
      color: #fff !important;
      font-size: 1.125rem !important;
    }
    .ant-menu-item-selected {
      background-color: rgba(255, 255, 255, 0.15) !important;
      color: #fff !important;
      border: none !important;

      &::after {
        display: none !important;
      }
    }
    .ant-menu-item:hover,
    .ant-menu-submenu-title:hover {
      background-color: rgba(255, 255, 255, 0.08) !important;
      color: #fff !important;
    }
    .ant-menu-submenu-popup .ant-menu {
      background: #0c0c0c !important;
      border: none !important;
    }
    .ant-menu-submenu-popup .ant-menu-item {
      padding: 14px 24px 14px 48px !important;
    }
  }
`;

export const CollapseButton = styled(Button) <{ $isCollapsed: boolean }>`
  background: var(--collapse-background-color);

  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
  position: absolute;
  left: 11.5rem;

  ${(props) =>
    props.$isCollapsed &&
    css`
      left: 4rem;
    `}

  color: var(--text-secondary-color);

  &:hover {
    color: var(--text-secondary-color);
    background: var(--primary-color);
    border: 1px solid var(--border-color);
  }

  &:focus {
    color: var(--text-secondary-color);
    background: var(--primary-color);
    border: 1px solid var(--border-color);
  }
`;

export const SiderContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - ${LAYOUT.mobile.headerHeight});

  @media only screen and ${media.md} {
    max-height: calc(100vh - ${LAYOUT.desktop.headerHeight});
  }
`;

export const SiderLogoLink = styled(Link)`
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
`;

export const SiderLogoDiv = styled.div`
  height: ${LAYOUT.mobile.headerHeight};
  padding: ${LAYOUT.mobile.headerPadding};
  justify-content: space-between;
  align-items: center;

  @media only screen and ${media.md} {
    height: ${LAYOUT.desktop.headerHeight};
    padding-top: ${LAYOUT.desktop.paddingVertical};
    padding-bottom: ${LAYOUT.desktop.paddingVertical};
  }
`;

export const BrandSpan = styled.span`
  margin: 0 1rem;
  font-weight: 700;
  font-size: 1.125rem;
  color: var(--white);
`;

export const CalibLogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 20px;

  h3 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    color: #fff;
    text-align: center;
  }
`;
